<!--
 * @Author: Latte
 * @Date: 2021-05-27 16:34:31
 * @LAstEditors: Latte
 * @LastEditTime: 2021-12-01 15:52:24
 * @FilePath: \Siui.Cloud.Medical.Web\src\views\systemManagement\userManagement\userDetail\index.vue
-->

<template>
	<div class="app-container">
		<el-button class="go-back" size="small" type="primary" @click.stop="goBack()">
			返回
		</el-button>

		<el-tabs v-model="activeIndex" type="border-card">
			<!-- 用户详情 -->
			<el-tab-pane label="用户详情" name="0">
				<el-form ref="userFormRef" :model="userForm" label-width="120px" :rules="rules">
					<el-row style="display: flex;" :gutter="20">
						<el-col :span="8">
							<el-form-item label="头像">
								<el-upload ref="uploadAvatarRef" accept=".png,.jpg" action=""
									:http-request="uploadAvatar" :limit="1" :show-file-list="false">
									<el-avatar :key="userForm.avatar" :loading="avatarLoading" :size="60"
										:src="config.RESOURCES+userForm.avatar" />
								</el-upload>
							</el-form-item>
						</el-col>
						<el-col :span="8">
              <el-form-item label="修改密码">
                <el-row>
                  <el-input v-model="pwd" placeholder="输入要修改的密码" type="password" clearable style="width:65%"></el-input>
                  <el-button style="margin-left: 10px;" size="small" type="primary" @click="resetPWD">修改
                  </el-button>
                </el-row>
              </el-form-item>
						</el-col>
					</el-row>

					<el-row :gutter="20">
						<el-col :span="8">
							<el-form-item v-if="userDataTypeOptions.length > 0" label="用户类型">
								<el-radio-group v-model="userForm.userType">
                  <el-radio v-for="item in userDataTypeOptions"  :label="item.value">{{item.name}}</el-radio>
									</el-radio-group>
							</el-form-item>
						</el-col>
						<el-col :span="8">
							<el-form-item label="用户角色">
								<el-select v-model="inputRoleList" multiple placeholder="请选择" style="width: 100%">
									<el-option v-for="item in roleList" :key="item.roleID" :label="item.roleName"
										:value="item.roleID" />
								</el-select>
							</el-form-item>
						</el-col>
					</el-row>

					<el-row :gutter="20">
						<el-col :span="8">
							<el-form-item label="宏云号" required>
								<el-input v-model="userForm.loginName" autocomplete="off" />
							</el-form-item>
						</el-col>
						<el-col :span="8">
							<el-form-item label="用户昵称" required>
								<el-input v-model="userForm.nickname" autocomplete="off" />
							</el-form-item>
						</el-col>
					</el-row>

					<el-row :gutter="20">
						<el-col :span="8">
							<el-form-item label="姓氏" required>
								<el-input v-model="userForm.firstName" autocomplete="off" />
							</el-form-item>
						</el-col>
						<el-col :span="8">
							<el-form-item label="名字" required>
								<el-input v-model="userForm.lastName" autocomplete="off" />
							</el-form-item>
						</el-col>
					</el-row>

					<el-row :gutter="20">
						<el-col :span="8">
							<el-form-item label="邮箱号" prop="loginEmail">
								<el-input v-model="userForm.loginEmail" autocomplete="off" />
							</el-form-item>
						</el-col>
						<el-col :span="8">
							<el-form-item label="手机号" required prop="mobilePhone">
								<el-input v-model="userForm.mobilePhone" autocomplete="off" />
							</el-form-item>
						</el-col>
					</el-row>

					<el-row :gutter="20">
						<el-col :span="8">
							<el-form-item label="性别">
								<el-radio-group v-model="userForm.sex">
									<el-radio :label="0">男</el-radio>
									<el-radio :label="1">女</el-radio>
									<el-radio :label="2">未知</el-radio>
								</el-radio-group>
							</el-form-item>
						</el-col>

						<el-col :span="8">
							<el-form-item label="创建时间">
								<el-date-picker v-model="userForm.createDate" type="date" placeholder="选择日期" disabled
									style="width: 100%" value-format="yyyy-MM-dd hh:mm:ss" />
							</el-form-item>
						</el-col>
					</el-row>
					<el-row :gutter="20">
						<el-col :span="8">
							<el-form-item label="工作单位">
								<el-input v-model="userForm.organization" autocomplete="off" type="textarea"/>
							</el-form-item>
						</el-col>
            <el-col :span="8">
              <el-form-item label="联系地址">
                <el-input v-model="userForm.address" autocomplete="off" type="textarea"/>
              </el-form-item>
            </el-col>
					</el-row>
          <el-row :gutter="20" v-if="getShowNetDiskAccess()">
            <el-col :span="8">
              <el-form-item label="云盘已使用容量">
                <div style="display:flex;flex-direction: row">
                  <el-progress width="55" type="circle"
                               :percentage="(100*this.diskConfig.usedCapacity/(this.newCapacity*1024*1024)).toFixed(2)"></el-progress>
                  <div style="padding-top:11px;padding-left:10px">{{ getCapacityInfo(this.diskConfig.usedCapacity) }}</div>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="云盘容量(GB)">
                <div style="display:flex;flex-direction: row">
                  <div>
                    <el-input-number v-model="newCapacity" :min="1" :max="50"></el-input-number>
                  </div>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="16">
            <el-form-item label="用户服务">
              <el-checkbox-group v-model="selectedUserServices">
                <el-checkbox v-for="item in userServices" :label="item.name" :key="item.id">{{item.name}}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            </el-col>
          </el-row>

					<!-- 跟APP统一，去除地区设置 -->
					<!-- <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="国家">
                <el-select
                  v-model="userForm.nationality"
                  placeholder="请选择"
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in nationalityOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="省份">
                <el-select
                  v-model="userForm.province"
                  placeholder="请选择"
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in provinceOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="城市">
                <el-select
                  v-model="userForm.city"
                  placeholder="请选择"
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in cityOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row> -->

					<el-form-item>
						<el-button type="primary" size="small" @click="updateUser()">
							保存修改
						</el-button>
					</el-form-item>
				</el-form>
			</el-tab-pane>
		</el-tabs>
	</div>
</template>

<script>
	import {
		getOne,
		updateUser,
		getUserService
	} from "@/api/userDetail";
	import {
		getRoleList,
		userBindRole,
		getUserRole
	} from "@/api/role";
	import {
		getOSSUploadInfo
	} from "@/api/system/CSDocument/file";
	import {
		uploadFile2OSS
	} from "@/utils/OSSUpload";
	import {
		handleRes
	} from "@/utils/handleRes"
	import md5 from "js-md5";
  import {getUserType} from "@/utils/userutil";
  import {
    getUserCapacity,
    resetUserCapacity
  } from "@/api/system/netDisk/netDisk";
  import config from "@/utils/config";

	export default {

		data() {
			return {
        userDataTypeOptions:[],
				activeIndex: "0", // 当前索引
				pwd: "",
				userForm: {
					roleList: [],
				}, // 用户详情表单
				userID: "", // 用户ID
				UserType: 0,
				sexRadio: "1",
				typeRadio: "1",
				nationalityOptions: [{
						value: "一级",
						label: "一级",
					},
					{
						value: "二级",
						label: "二级",
					},
					{
						value: "三级",
						label: "三级",
					},
				],
				provinceOptions: [{
						value: "一级",
						label: "一级",
					},
					{
						value: "二级",
						label: "二级",
					},
					{
						value: "三级",
						label: "三级",
					},
				],
				cityOptions: [{
						value: "一级",
						label: "一级",
					},
					{
						value: "二级",
						label: "二级",
					},
					{
						value: "三级",
						label: "三级",
					},
				],
				roleList: [
					// {
					//   roleID: 1,
					//   roleName: "超级管理员",
					// },
					// {
					//   roleID: 2,
					//   roleName: "普通用户",
					// },
				], // 角色列表
				inputRoleList: [],
				rules: {
					loginEmail: [{
						type: "email",
						message: '邮箱格式不正确',
						trigger: ['blur', 'change']
					}],
				},
				avatarLoading: false,
				userServices: [],
				selectedUserServices: [],
        diskConfig:{}, // 网盘容量
        newCapacity: 0, // 新设置的网盘容量
        minCapacity: 0
			};
		},
		async created() {
      this.userDataTypeOptions = getUserType()
			this.userID = this.$route.query.userID;
			await this.refreshCurrentList();
		},
		methods: {
      // 获取网盘设置权限
      getShowNetDiskAccess(){
        return this.config.SHOW_NET_DISK_INFO === 'true'
      },
			resetPWD() {
				if (this.pwd.length < 6) {
					this.$message.warning('密码长度至少6位')
					return
				}
				updateUser({
					"password": md5(this.pwd),
					userID: this.userID,
				}).then(res => {
					handleRes(res, () => {
						this.$message.success("修改成功")
						this.pwd = ""
					})
				})
			},
			/**
			 * 刷新页面
			 */
			async refreshCurrentList() {
				await this.getOne();
				await this.getRoleList();
				await this.getUserBindRole();
				await this.getUserService();
        await this.getUserCapacity();
			},
      /**
       * 获取用户网盘容量
       */
      getUserCapacity() {
        if(this.config.SHOW_NET_DISK_INFO === 'true'){
          getUserCapacity({userId: this.userID}).then((res) => {
            if (res.code === 200) {
              this.diskConfig = res.data
              if (this.diskConfig.usedCapacity === null) {
                this.diskConfig.usedCapacity = 0
              }
              this.minCapacity = this.diskConfig.usedCapacity/1024
              this.newCapacity = (res.data.allCapacity/1024/1024).toFixed(2)
            }
          })
        }
      },
      /**
       * 修改用户网盘容量
       */
      updateUserCapacity(){
        if(this.config.SHOW_NET_DISK_INFO === 'true'){
          const capacity = this.newCapacity*1024*1024
          let param={userId: this.userID, allCapacity: capacity}
          const data = {
            ...param
          };
          resetUserCapacity(data).then((res) => {
            if (res.code === 200) {
              this.getUserCapacity()
            }
          })
        }
      },
      getCapacityInfo(num) {
        if (num < 1024) {
          return num + 'KB'
        } else if (num < 1024 * 1024) {
          return (num / 1024).toFixed(2) + 'MB'
        } else if (num < 1024 * 1024 * 1024) {
          return (num / 1024 / 1024).toFixed(2) + 'GB'
        }
      },
			/**
			 *
			 */
			goBack() {
				this.$router.go(-1);
			},
			/**
			 * 获取单个用户详情
			 */
			getOne() {
				const params = {
					userID: this.userID,
				};
				getOne(params).then((res) => {
					this.userForm = res.data;
				});
			},
			/**
			 * 更新单个用户详情
			 */
			updateUser() {

				this.$refs.userFormRef.validate((value) => {
					if (value) {
						const data = this.userForm;
						updateUser(data).then(async (res) => {
							if (res.isError) {
								this.$message.error(res.errorMessage);
								return;
							}

							await this.userBindRole();
              await this.updateUserCapacity();

							this.$message({
								type: "success",
								message: "保存成功",
							});
							this.refreshCurrentList();
						});
					} else {
						this.$message({
							type: "info",
							message: "提交数据有误"
						})
					}
				})

			},
			/**
			 * @description: 查询所有角色列表
			 * @param {*}
			 * @return {*}
			 */
			getRoleList() {
				getRoleList().then((res) => {
					return res.data.totalCount

				}).then((res) => {
					return getRoleList({
						pageSize: res
					})
				}).then((res) => {
					this.roleList = res.data.result.map((e) => {
						return {
							roleID: e.roleID,
							roleName: e.roleName,
						};
					});
				});
			},
			/**
			 * @description: 用户绑定角色
			 * @param {*}
			 * @return {*}
			 */
			async userBindRole() {

				const params = {
					userID: this.userID,
					roleIDArray: this.inputRoleList.length === 0 ? '' : this.inputRoleList,
				};
				await userBindRole(params);
			},
			/**
			 * @description: 获取用户所绑定的角色
			 * @param {*}
			 * @return {*}
			 */
			async getUserBindRole() {
				const params = {
					userID: this.userID,
				};
				const result = await getUserRole(params);
				this.inputRoleList = result.data.map((e) => {
					return e.roleID;
				});
			},
			/**
			 * 上传头像
			 * @param {Object} file
			 */
			async uploadAvatar(file) {
				this.avatarLoading = true;
				let ossInfo = (await getOSSUploadInfo({
					DataType: 1,
					ID: this.userID
				})).resultData;
				let timestamp = new Date().valueOf();
				const fileName = ossInfo.PicSavePath + timestamp + file.file.name.substring(file.file.name.lastIndexOf("."));
				//console.log("upload info " + ossInfo.PicSavePath + " " + fileName)
				let uploadRes = await uploadFile2OSS(ossInfo, file.file, fileName)
				if (uploadRes.status === 0) {
					this.userForm.avatar = "/" + fileName
				} else {
					this.$message({
						type: "error",
						message: "上传失败"
					})
				}
				this.$refs.uploadAvatarRef.clearFiles();
				this.avatarLoading = false;
			},
			/**
			 * 获取用户能使用的服务
			 */
			async getUserService() {
				this.userServices = getUserService()
				console.log("getUserService " + this.userServices[0])
			}
		},
	};
</script>

<style scoped lang="scss"></style>
